import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CustomDropdown({ label, items = [], selected, onSelect }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      {/* Dropdown Button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between gap-2 rounded-xl border border-blue-300 
                   bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-2 text-sm font-medium 
                   text-blue-700 shadow-sm hover:from-blue-100 hover:to-indigo-100 transition"
      >
        {selected || label}
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </motion.svg>
      </button>

      {/* Dropdown Menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 z-50 mt-2 w-40 rounded-xl border border-blue-100 
                       bg-white shadow-lg ring-1 ring-black/5 overflow-hidden"
          >
            {items.map((item) => (
              <button
                key={item}
                onClick={() => {
                  onSelect(item);
                  setOpen(false);
                }}
                className={`block w-full px-4 py-2 text-left text-sm text-gray-700 
                            hover:bg-blue-50 hover:text-blue-600 transition 
                            ${selected === item ? "bg-blue-100 text-blue-700 font-semibold" : ""}`}
              >
                {item}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
